"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var Icon_1 = __importDefault(require("../../Icon"));
var Icons_1 = require("../../Icons");
var ToastElement_1 = __importDefault(require("../ToastElement"));
var DefaultToast = function (_a) {
    var appearance = _a.appearance, autoDismiss = _a.autoDismiss, autoDismissTimeout = _a.autoDismissTimeout, children = _a.children, isRunning = _a.isRunning, onDismiss = _a.onDismiss, placement = _a.placement, transitionDuration = _a.transitionDuration, transitionState = _a.transitionState, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, otherProps = __rest(_a, ["appearance", "autoDismiss", "autoDismissTimeout", "children", "isRunning", "onDismiss", "placement", "transitionDuration", "transitionState", "onMouseEnter", "onMouseLeave"]);
    return (react_1["default"].createElement(ToastElement_1["default"], __assign({ appearance: appearance, placement: placement, transitionState: transitionState, transitionDuration: transitionDuration, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }, otherProps),
        react_1["default"].createElement(Icon_1["default"], { appearance: appearance, autoDismiss: autoDismiss, autoDismissTimeout: autoDismissTimeout, isRunning: isRunning }),
        react_1["default"].createElement("div", { className: "react-toast-notifications__toast__content" }, children),
        onDismiss ? (react_1["default"].createElement("div", { role: "button", className: "react-toast-notifications__toast__dismiss-button", onClick: onDismiss },
            react_1["default"].createElement(Icons_1.CloseIcon, { className: "react-toast-notifications__toast__dismiss-icon react-toast-notifications__toast__dismiss-icon--" + appearance }),
            react_1["default"].createElement("span", { className: "react-toast-notifications__toast__dismiss-text" }))) : null));
};
DefaultToast.defaultProps = {
    onDismiss: function () {
        return;
    }
};
exports["default"] = DefaultToast;
